import request from "@/utils/request";

export const writeMessage = (p) => request({
  url: "/admin/netty/write",
  method: "get",
  params: p
});

export const syncTimeMessage = (p) => request({
  url: "/admin/netty/write/synctime",
  method: "get",
  params: p
});
export const readTimeMessage = (p) => request({
  url: "/admin/netty/write/readtime",
  method: "get",
  params: p
});
export const syncServerConfig = (p) => request({
  url: "/admin/netty/write/syncconfig",
  method: "get",
  params: p
});
export const getStationVer = (p) => request({
  url: "/admin/netty/write/stationVer",
  method: "get",
  params: p
});
export const stationUpgrade = (p) => request({
  url: "/admin/netty/write/stationUpgrade",
  method: "get",
  params: p
});
export const sendPointConfig = (p) => request({
  url: "/admin/netty/write/getAllPoint",
  method: "get",
  params: p
});
export const startSeriesRequest = (p) => request({
  url: "/admin/netty/write/startSeries",
  method: "get",
  params: p
});
export const stopSeriesRequest = (p) => request({
  url: "/admin/netty/write/stopSeries",
  method: "get",
  params: p
});
export const getAllPointDataRequest = (p) => request({
  url: "/admin/netty/write/getAllPointData",
  method: "get",
  params: p
});
export const getSinglePointDataRequest = (p) => request({
  url: "/admin/netty/write/getSinglePointData",
  method: "get",
  params: p
});
export const noticeChangeRequest = (p) => request({
  url: "/admin/netty/write/noticeChange",
  method: "get",
  params: p
});
export const getSentTimeIntervalRequest = (p) => request({
  url: "/admin/netty/write/getSentTimeInterval",
  method: "get",
  params: p
});
